var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["management-workspace-map"],
      attrs: { id: "map", type: "light", oncontextmenu: "return false" }
    },
    [
      _c("div", { staticClass: "management-map-buttons" }, [
        _vm.showZoomButtons
          ? _c(
              "div",
              { staticClass: "buttons-container" },
              [
                _c("custom-button", {
                  attrs: {
                    icon: "add",
                    width: "20px",
                    height: "20px",
                    iconSize: 12,
                    buttonStyling: _vm.buttonStyling
                  },
                  on: { buttonClick: _vm.zoomIn }
                }),
                _vm._v(" "),
                _c("custom-button", {
                  attrs: {
                    icon: "remove",
                    width: "20px",
                    height: "20px",
                    iconSize: 12,
                    buttonStyling: { padding: "8px", borderRadius: "4px" }
                  },
                  on: { buttonClick: _vm.zoomOut }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showCenterMapButton
          ? _c(
              "div",
              { staticClass: "buttons-container" },
              [
                _c("custom-button", {
                  attrs: {
                    icon: "location_searching",
                    width: "20px",
                    height: "20px",
                    iconSize: 12,
                    buttonStyling: _vm.buttonStyling,
                    disabled: !_vm.mapHasFeatures
                  },
                  on: { buttonClick: _vm.centerMap }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showCoordinatesButton
          ? _c(
              "div",
              { staticClass: "buttons-container hoverable" },
              [
                !_vm.showCoordinatesInputs
                  ? _c("custom-button", {
                      attrs: {
                        icon: "location_on",
                        height: "20px",
                        iconSize: 12,
                        buttonStyling: _vm.buttonStyling,
                        label: _vm.$tc("Coordinate", 2),
                        showLabelOnHover: ""
                      },
                      on: { buttonClick: _vm.openCoordinatesInputs }
                    })
                  : _c(
                      "div",
                      { staticClass: "coordinates-inputs-container" },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: { size: 12, color: "#FFFFFF" },
                            on: { click: _vm.closeCoordinatesInputs }
                          },
                          [_vm._v("\n          location_on\n        ")]
                        ),
                        _vm._v(" "),
                        _c("input-field", {
                          key: "latitude",
                          attrs: {
                            "input-type": "float",
                            value: _vm.coordinates.latitude,
                            placeholder: _vm.$t("Latitude"),
                            min: -90,
                            max: 90,
                            size: "medium",
                            inputFieldContainerStyling:
                              _vm.coordinatesInputsContainerStyling,
                            inputStyle: _vm.coordinatesInputsStyling
                          },
                          on: {
                            input: function($event) {
                              _vm.coordinates.latitude = $event
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input-field", {
                          key: "longitude",
                          attrs: {
                            "input-type": "float",
                            value: _vm.coordinates.longitude,
                            placeholder: _vm.$t("Longitude"),
                            min: -180,
                            max: 180,
                            size: "medium",
                            inputFieldContainerStyling:
                              _vm.coordinatesInputsContainerStyling,
                            inputStyle: _vm.coordinatesInputsStyling
                          },
                          on: {
                            input: function($event) {
                              _vm.coordinates.longitude = $event
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "v-icon",
                          {
                            attrs: { size: 12, color: "#FFFFFF" },
                            on: { click: _vm.centerOnCoordinates }
                          },
                          [_vm._v("\n          done\n        ")]
                        )
                      ],
                      1
                    )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showUploadGeomFromFileButton
          ? _c(
              "div",
              { staticClass: "buttons-container" },
              [
                _c("custom-button", {
                  attrs: {
                    icon: "cloud_upload",
                    height: "20px",
                    iconSize: 12,
                    buttonStyling: _vm.buttonStyling,
                    label: _vm.$t("AreaFromFile"),
                    showLabelOnHover: ""
                  },
                  on: { buttonClick: _vm.openUploadGeomFileDialog }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showRestartButton
          ? _c(
              "div",
              { staticClass: "buttons-container" },
              [
                _c("custom-button", {
                  attrs: {
                    icon: "restart_alt",
                    height: "20px",
                    iconSize: 12,
                    buttonStyling: _vm.buttonStyling,
                    label: _vm.$t("Restart"),
                    disabled: !_vm.featureIsDrawn,
                    showLabelOnHover: ""
                  },
                  on: { buttonClick: _vm.resetPolygon }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showAllWorkspacesButton
          ? _c(
              "div",
              { staticClass: "buttons-container" },
              [
                _c("custom-button", {
                  attrs: {
                    icon: "mdi-eye",
                    height: "20px",
                    iconSize: 12,
                    buttonStyling: _vm.buttonStyling,
                    label: _vm.$t("ViewAllWorkspaces"),
                    showLabelOnHover: ""
                  },
                  on: { buttonClick: _vm.showHideAllWorkspacesMethod }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("dialog-content", {
        attrs: {
          isOpen: _vm.uploadGeomFileDialogIsOpen,
          isPersistent: true,
          onClose: _vm.closeUploadGeomFileDialog,
          "card-style": { display: "table" }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "tabs-custom" },
                  [
                    _c("Tabs", {
                      attrs: {
                        tabs: _vm.uploadFileDialogTabs,
                        activeTab: 0,
                        "center-tabs": false
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tabs-content-custom" },
                  [
                    _c("InputField", {
                      attrs: {
                        inputStyle: {
                          backgroundColor: "white"
                        },
                        inputFieldContainerStyling:
                          _vm.uploadFileInputContainersStyle,
                        inputType: "select",
                        value: _vm.fileType,
                        "select-options-list": _vm.fileTypeOptions,
                        label: _vm.$tc("Type", 1),
                        required: "",
                        size: "large"
                      },
                      on: {
                        input: function($event) {
                          _vm.fileType = $event
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("InputField", {
                      attrs: {
                        inputStyle: {
                          backgroundColor: "white"
                        },
                        inputFieldContainerStyling:
                          _vm.uploadFileInputContainersStyle,
                        "input-type": "select",
                        value: _vm.fileProjection,
                        "select-options-list": _vm.fileProjectionOptions,
                        label: _vm.$tc("Projection", 1),
                        required: "",
                        size: "large"
                      },
                      on: {
                        input: function($event) {
                          _vm.fileProjection = $event
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("InputField", {
                      ref: "fileInput",
                      attrs: {
                        inputStyle: {
                          color: "#767676 !important"
                        },
                        inputFieldContainerStyling:
                          _vm.uploadFileInputContainersStyle,
                        inputType: "file",
                        size: "large",
                        fileTypes: _vm.acceptedFileTypes,
                        value: _vm.file,
                        required: ""
                      },
                      on: {
                        input: function($event) {
                          _vm.file = $event
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "buttons-container-custom" },
                      [
                        _c("CustomButton", {
                          attrs: {
                            label: _vm.$t("Cancel"),
                            "button-color": "#FFF",
                            "label-color": "var(--app-primary-base)",
                            buttonStyling: _vm.uploadFileCancelButtonStyle
                          },
                          on: { buttonClick: _vm.closeUploadGeomFileDialog }
                        }),
                        _vm._v(" "),
                        _c("CustomButton", {
                          attrs: {
                            label: _vm.$t("Submit"),
                            "button-styling": _vm.uploadFileCancelButtonStyle,
                            disabled: _vm.uploadFileSubmitButtonIsDisabled
                          },
                          on: { buttonClick: _vm.submitForm }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("LoadingSpinner", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d0b032c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d0b032c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Molecules/ManagementMap.vue
// module id = null
// module chunks = 